import { SharedAngular } from '@Client/@types/sharedAngular';
import { FormThemesApiServiceType } from '@Shared.Angular/flowingly.services/formthemes.api.service';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import angular from 'angular';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.library, {
    url: 'library',
    templateUrl: 'Client/runner.library/runner.library.tmpl.html',
    controller: [
      'flowModelApiService',
      'procedureApiService',
      'formThemesApiService',
      function (
        flowModelApiService: SharedAngular.FlowModelApiService,
        procedureApiService: SharedAngular.ProcedureApiService,
        formThemesApiService: FormThemesApiServiceType
      ) {
        // Reset loaded flags so child tab controllers re-fetch on each library visit
        flowModelApiService.flowModelsLoaded = false;
        procedureApiService.proceduresLoaded = false;
        formThemesApiService.formThemesLoaded = false;
      }
    ],
    resolve: {
      categories: [
        'categoryApiService',
        function (categoryApiService: SharedAngular.CategoryApiService) {
          // These are preloaded so the category service will have the categories
          // cached for use in the category column filters
          return categoryApiService.getCategories();
        }
      ]
    }
  });
}
